export default __webpack_public_path__ + "static/media/meAndSkids.c8768003.jpg";